var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAugmentedApplications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baeef694-a770-473f-83a9-3a4b6db911a8",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .abe89cc8-7a45-436b-a20b-a86a21076601 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "abe89cc8-7a45-436b-a20b-a86a21076601",
    x: 28.423,
    y: 31.778,
    width: 19.648,
    height: 19.648,
    rx: 4.231
  }), /*#__PURE__*/React.createElement("rect", {
    className: "abe89cc8-7a45-436b-a20b-a86a21076601",
    x: 51.929,
    y: 31.778,
    width: 19.648,
    height: 19.648,
    rx: 4.231
  }), /*#__PURE__*/React.createElement("rect", {
    className: "abe89cc8-7a45-436b-a20b-a86a21076601",
    x: 28.423,
    y: 8.656,
    width: 19.648,
    height: 19.648,
    rx: 4.231
  }), /*#__PURE__*/React.createElement("rect", {
    className: "abe89cc8-7a45-436b-a20b-a86a21076601",
    x: 52.513,
    y: 10.347,
    width: 17.023,
    height: 17.023,
    rx: 4.231,
    transform: "translate(31.209 -37.628) rotate(45)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugmentedApplications);
export default __webpack_public_path__ + "static/media/AugmentedApplications.4c107a561a3d296f48e99a3ead4b6773.svg";
export { ForwardRef as ReactComponent };